import { TextField } from '@cmsgov/ds-medicare-gov';
import { ChangeEventHandler, FocusEventHandler } from 'react';
import { Link } from 'react-router-dom';
import { trackLinkClick } from '../analytics';
import translate from '../functions/translate';
import Div from './div';

interface UserNameSectionProps {
    onChange: ChangeEventHandler<HTMLInputElement>
    onBlur: FocusEventHandler<HTMLInputElement>
    value: string
    label: string
    errorMessage: string | null
    inputRef: (ref: HTMLInputElement) => void
    onFocus: () => void
}

const UserNameSection = (props: UserNameSectionProps) => {
    return <>
        <Div isRow>
            <Div cols={11} colsSM={10} colsMD={9} colsLG={6} colsXL={5}>
                <TextField
                    errorMessage={props.errorMessage}
                    id={'username-textbox'}
                    inputRef={props.inputRef}
                    label={translate('username')}
                    name={'username'}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    onFocus={props.onFocus}
                    value={props.value}
                />
            </Div>
            <Div cols={12} marginTop={0}>
                <Link
                    onClick={trackLinkClick(translate('login'))}
                    to="/forgot-username"
                >{translate('forgot_username_question_mark')}</Link>
            </Div>
        </Div>
    </>;
};

export default UserNameSection;
